import { render, staticRenderFns } from "./fundSave.vue?vue&type=template&id=62e94b60&scoped=true&"
import script from "./fundSave.vue?vue&type=script&lang=js&"
export * from "./fundSave.vue?vue&type=script&lang=js&"
import style0 from "./fundSave.vue?vue&type=style&index=0&id=62e94b60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e94b60",
  null
  
)

export default component.exports